<div
    class="sidenav {{isCollapsed ? '' : 'sidenav-opened' }} {{store.state.common.sidemenuSmall ? 'sidenav-small' : ''}}">
    <span (click)="toggleSideBar()" class="side-menu-toggler">
        <i class="far {{store.state.common.sidemenuSmall ? 'fa-angle-right' : 'fa-angle-left'}}"></i>
    </span>
    <div #stickySidenav
        class="sidenav-sticky d-flex justify-content-center align-content-center flex-column {{scrollVisible ? 'has-scroll' : ''}}"
        (mouseover)="resetCollapsed()">

        <ul class="sidenav-items sidenav-items-top mb-auto pb-3 mt-2">
            <li class="mb-4">
                <a routerLink="/services" class="sidenav-item nohover">
                    <img class="logo" src="./assets/gfx/logo-no-text-white.png" width="40px">
                    <!--<img class="d-none d-md-inline-block" src="./assets/gfx/Er-logo-white.svg">-->
                    <span>{{ systemProperties?.value?.siteName || systemProperties?.siteName }}</span>
                </a>
            </li>
            <li class="dropdown mb-1" dropdown placement="right" container="body">
                <a href="#" (click)="false" class="sidenav-item"
                    tooltip="{{(store.state.common.sidemenuSmall ? 'Servers status' : '') | translate}}"
                    placement="left" container="body" containerClass="nav-tooltip" dropdownToggle>
                    <i
                        class="fad fa-circle-dot {{ gUp === 1 ? ' text-success' : ( gUp === -1 ? 'text-danger' : 'text-warning')}}"></i>
                    <span><span
                            class="badge badge-instance badge-{{(env && env.BUILD_TYPE ? env.BUILD_TYPE : 'LIVE').toLowerCase()}} mr-1">{{env
                            && env.BUILD_TYPE ? env.BUILD_TYPE : 'LIVE'}}</span> {{ env && env.EREGISTRATIONS_VERSION ?
                        env.EREGISTRATIONS_VERSION : 'x.y'}}</span>
                </a>
                <div class="dropdown-menu dropdown-menu-top-right services-dropdown" *dropdownMenu>
                    <!-- Core services only in dropdown -->
                    <a *ngFor="let service of getServicesByCategory('core')"
                       class="dropdown-item cursor-pointer py-1"
                       href="https://docs.google.com/document/d/1ZsPFT0A698gk_8R5qgS4xpCjCy3GHyPppnehcYiFOow"
                       target="_blank">
                        <i class="fad fa-circle-dot mr-2"
                           [ngClass]="{'text-success': service.health, 'text-danger': !service.health}"
                           style="font-size: 0.7rem"></i>
                        <span class="small">{{service.displayName}} {{service.version}}
                            <span class="text-muted">({{service.branch}})</span>
                        </span>
                    </a>
                    <div class="dropdown-divider m-0"></div>
                    <a class="dropdown-item cursor-pointer py-2 text-primary" (click)="isServicesDrawerClosed = false; $event.stopPropagation();">
                        <i class="far fa-server mr-2" style="font-size: 0.8rem"></i>
                        <span class="small">{{'Show all statuses' | translate}} ({{serviceStatuses.size}})</span>
                    </a>
                    <div *ngIf="bpaDeploy" class="dropdown-divider m-0"></div>
                    <a *ngIf="bpaDeploy"
                        class="updates-toggle cursor-pointer dropdown-item ng-star-inserted d-flex align-items-center {{env.production ? 'hidden' : ''}}"
                        (click)="toggleDeployEnabled()">
                        <i
                            class="fas fa-toggle-large-on {{bpaDeploy.deployEnabled ? 'text-success' : 'fa-flip-horizontal toggle-disabled'}}"></i>
                        <span>{{'Updates' | translate}}</span>
                    </a>
                </div>
            </li>
            <li class="dropdown mb-1" dropdown placement="right" container="body">
                <a href="#" (click)="false" class="sidenav-item"
                    tooltip="{{(store.state.common.sidemenuSmall ? 'Users in the system' : '') | translate}}"
                    placement="left" container="body" containerClass="nav-tooltip" dropdownToggle>
                    <i class="fad fa-user {{askForPage && showPageRequest ? 'text-warning' : ''}}"></i>
                    <span>{{ currentlyLoggedInCount }}</span>
                </a>
                <div class="dropdown-menu dropdown-menu-top-right" *dropdownMenu>
                    <h6 class="dropdown-header">{{"Users in current page" | translate}}</h6>
                    <a *ngFor="let usr of urlsToUsers" class="dropdown-item nohover py-2" (click)="false">
                        <i class="fad fa-user {{(usr.connId === pageOwner.connId && showPageRequest) ? 'text-warning' : 'text-primary'}} mr-3"
                            style="font-size:0.9rem"></i>
                        <span>{{formatUserName(usr)}}</span>
                    </a>
                    <h6 class="dropdown-header">{{"Users in the system" | translate}}</h6>
                    <a *ngFor="let usr of systemUsers" class="dropdown-item nohover py-2" (click)="false">
                        <i class="fad fa-user text-primary mr-3" style="font-size:0.9rem"></i>
                        <span>{{usr.fullName || usr.email}}</span>
                    </a>
            <li *ngIf="askForPage" class="dropdown-divider mb-0"></li>
            <a *ngIf="askForPage" class="dropdown-item p-3" (click)="false">
                <button (click)="requestPageAccess()"
                    class="btn btn-block btn-outline-primary {{askingForPage ? 'active' : ''}}">{{'Request page access'
                    | translate}}</button>
            </a>

    </div>
    </li>
    <li class="dropdown mb-1" dropdown placement="right" container="body">
        <a href="#" (click)="false" class="sidenav-item"
            tooltip="{{(store.state.common.sidemenuSmall ? 'Language' : '') | translate}}" placement="left"
            container="body" containerClass="nav-tooltip" dropdownToggle>
            <i *ngIf="!store.state.common.sidemenuSmall" class="far fa-earth-americas" style="font-size:0.9rem"></i>
            <span>{{'Language' | translate}}</span>
            <div class="btn-group-primary-light d-inline-block {{store.state.common.sidemenuSmall ? '' : 'ml-auto'}}">
                <button class="text-uppercase active">{{translateService.currentLang ||
                    translateService.getDefaultLang()}}</button>
            </div>
        </a>
        <div class="dropdown-menu dropdown-menu-bottom-right" *dropdownMenu>
            <a class="dropdown-item nohover p-2" (click)="false">
                <div class="btn-group-primary-light d-inline-block">
                    <button *ngFor="let lang of translateService.getLangs()" (click)="changeLanguage(lang)"
                        class="text-uppercase {{(translateService.currentLang || translateService.getDefaultLang()) === lang ? 'active' : ''}}">
                        {{ lang }}
                    </button>
                </div>
            </a>
        </div>
    </li>
    <li class="dropdown mb-1" dropdown placement="right" container="body">
        <a href="#" (click)="false" class="sidenav-item {{isSettingsSection ? 'active' : ''}}"
            tooltip="{{(store.state.common.sidemenuSmall ? 'header.settings' : '') | translate}}" placement="left"
            container="body" containerClass="nav-tooltip" dropdownToggle>
            <i class="far fa-cog"></i>
            <span>{{ 'header.settings' | translate }}</span>
        </a>
        <div class="dropdown-menu dropdown-menu-top-right" *dropdownMenu>
            <a href="/translate" class="dropdown-item py-2" target="_blank">
                <i class="far fa-book mr-3" style="font-size:0.9rem"></i>
                <span>{{ 'header.manage_translation' | translate }}</span>
            </a>
            <a href="/settings" class="dropdown-item py-2" target="_blank">
                <i class="far fa-cog mr-3" style="font-size:0.9rem"></i>
                <span>{{ 'Instance settings' | translate }}</span>
            </a>
        </div>
    </li>
    </ul>
    <ul class="sidenav-items">
        <li>
            <a class="sidenav-item {{isServicesSection ? 'active' : ''}}" [routerLinkActiveOptions]="{exact:true}"
                tooltip="{{(store.state.common.sidemenuSmall ? 'nav.services' : '') | translate}}" placement="left"
                container="body" containerClass="nav-tooltip" routerLink="/services/" [routerLinkActive]="['active']">
                <i class="{{isServicesSection ? 'fad' : 'far'}} fa-circle-nodes"></i>
                <span>{{'nav.services' | translate}}</span>
            </a>
        </li>
        <li *ngIf="serviceId && serviceId !== defaultMyAccountServiceId" class="bordered-nav-item">
            <a class="sidenav-item {{isRegistrationSection ? 'active' : ''}}"
                routerLink="/services/{{serviceId}}/registrations/"
                tooltip="{{(store.state.common.sidemenuSmall ? 'nav.1_registrations' : '') | translate}}"
                placement="left" container="body" containerClass="nav-tooltip" [routerLinkActive]="['active']">
                <i class="{{isRegistrationSection ? 'fad' : 'far'}} fa-circle-o"></i>
                <span>{{'nav.1_registrations' | translate}}</span>
            </a>
        </li>
        <li *ngIf="serviceId && serviceId !== defaultMyAccountServiceId">
            <a class="sidenav-item {{isApplicationFileSection ? 'active' : ''}}"
                routerLink="/services/{{serviceId}}/forms/{{applicationFilePage}}" [routerLinkActive]="['active']"
                tooltip="{{(store.state.common.sidemenuSmall ? 'nav.2_application_file' : '') | translate}}"
                placement="left" container="body" containerClass="nav-tooltip"
                [routerLinkActiveOptions]="{exact: true}">
                <i class="{{isApplicationFileSection ? 'fad' : 'far'}} fa-file"></i>
                <span>{{'nav.2_application_file' | translate}}</span>
            </a>
        </li>
        <li *ngIf="serviceId && serviceId !== defaultMyAccountServiceId">
            <a class="sidenav-item {{isRolesSection ? 'active' : ''}}" routerLink="/services/{{serviceId}}/roles/"
                tooltip="{{(store.state.common.sidemenuSmall ? 'nav.3_roles' : '') | translate}}" placement="left"
                container="body" containerClass="nav-tooltip" [routerLinkActive]="['active']">
                <i class=" {{isRolesSection ? 'fad' : 'far'}} fa-timeline"></i>
                <span>{{'nav.3_roles' | translate}}</span>
            </a>
        </li>
        <li *ngIf="serviceId && store.state.common.userLevels.pages && store.state.common.userLevels.pages.SideNavLevel >= 2"
            class="bordered-nav-item">
            <a class="sidenav-item {{isBotsSection ? 'active' : ''}}" routerLink="/services/{{serviceId}}/actions/"
                tooltip="{{(store.state.common.sidemenuSmall ? 'Actions' : '') | translate}}" placement="left"
                container="body" containerClass="nav-tooltip" [routerLinkActive]="['active']">
                <i class="{{isBotsSection ? 'fad' : 'far'}} fa-bolt"></i>
                <span>
                    {{'Actions' | translate}}
                    <span class="sidenav-item-subtitle">{{'Bots & External links' | translate}}</span>
                </span>
            </a>
        </li>
        <li *ngIf="serviceId && store.state.common.userLevels.pages && store.state.common.userLevels.pages.SideNavLevel >= 2"
            class="bordered-nav-item">
            <a class="sidenav-item {{isTemplatesSection ? 'active' : ''}}"
                routerLink="/services/{{serviceId}}/templates/certificates" [routerLinkActive]="['active']"
                tooltip="{{(store.state.common.sidemenuSmall ? 'Templates' : '') | translate}}" placement="left"
                container="body" containerClass="nav-tooltip">
                <i class="{{isTemplatesSection ? 'fad' : 'far'}} fa-layer-group"></i>
                <span>
                    {{'Templates' | translate}}
                    <span class="sidenav-item-subtitle">{{'Messages & Certificates' | translate}}</span>
                </span>

            </a>
        </li>
        <li *ngIf="store.state.common.userLevels.pages && store.state.common.userLevels.pages.SideNavLevel >= 2"
            class="bordered-nav-item">
            <a class="sidenav-item {{isTablesSection ? 'active' : ''}} {{!isTablesCollapsed ? 'opened' : ''}}"
                target="_blank"
                routerLink="{{ serviceId ? '/services/' + serviceId + '/variables/instance-catalogs' : '/variables/instance-catalogs' }}"
                [routerLinkActive]="['active']"
                tooltip="{{(store.state.common.sidemenuSmall ? 'nav.annexes' : '') | translate}}" placement="left"
                container="body" containerClass="nav-tooltip" [routerLinkActiveOptions]="{exact: true}">
                <i class="{{isTablesSection ? 'fad' : 'far'}} fa-table"></i>

                <span>{{'nav.annexes' | translate}}</span>
            </a>
        </li>
        <li *ngIf="defaultMyAccountServiceId && store.state.common.userLevels.pages.SideNavLevel >= 2"
            class="bordered-nav-item">
            <a href="/services/{{defaultMyAccountServiceId}}/forms/applicant-form" [routerLinkActive]="['active']"
                tooltip="{{(store.state.common.sidemenuSmall ? 'My Account' : '') | translate}}" placement="left"
                container="body" containerClass="nav-tooltip" [routerLinkActiveOptions]="{exact: true}"
                class="sidenav-item {{(defaultMyAccountServiceId === serviceId) && isApplicationFileSection ? 'active' : ''}}">
                <i
                    class="{{(defaultMyAccountServiceId === serviceId) && isApplicationFileSection ? 'fad' : 'far'}} fa-house"></i>
                <span>{{ 'My Account' | translate }}</span>
            </a>
        </li>
    </ul>
    <ul class="sidenav-items sidenav-items-bottom mt-auto pt-3">
        <li class="mb-1" *ngIf="!externalServers || externalServers.length < 1">
            <a class="sidenav-item" href="{{env?.GDB_URL}}" target="_blank" tooltip="GDB" placement="left"
                containerClass="nav-tooltip">
                <i class="far fa-database"></i>
                <span>GDB</span>
            </a>
        </li>
        <li class="dropdown mb-1" dropdown placement="right" container="body"
            *ngIf="externalServers && externalServers.length > 0">
            <a href="#" (click)="false" class="sidenav-item"
                tooltip="{{(store.state.common.sidemenuSmall ? 'GDBs' : '')}}" placement="left" container="body"
                containerClass="nav-tooltip" dropdownToggle>
                <i class="far fa-database"></i>
                <span>GDB</span>
            </a>
            <div class="dropdown-menu dropdown-menu-bottom-right" *dropdownMenu>
                <a class="dropdown-item py-2" href="{{env?.GDB_URL}}" target="_blank">
                    <i class="far fa-database mr-3"></i>
                    <span>{{"locally" | translate}}</span>
                </a>
                <a class="dropdown-item py-2" *ngFor="let db of externalServers" href="{{db.gdb}}" target="_blank">
                    <i class="far fa-database mr-3"></i>
                    <span>{{db.name || ('External gdb' | translate)}}</span>
                </a>
            </div>
        </li>
        <li class="dropdown" dropdown placement="right" container="body" #dpLevel="bs-dropdown">
            <a href="#" (click)="false" class="sidenav-item"
                tooltip="{{(store.state.common.sidemenuSmall ? 'level.general' : '') | translate}}" placement="left"
                container="body" containerClass="nav-tooltip" dropdownToggle>
                <i *ngIf="!store.state.common.sidemenuSmall" class="far fa-layer-group"></i>
                <span>{{'level.general' | translate}}</span>
                <div
                    class="btn-group-primary-light d-inline-block {{store.state.common.sidemenuSmall ? '' : 'ml-auto'}}">
                    <button class="active">{{store.state.common.userLevels.pages["SideNavLevel"] || 1}}</button>
                </div>
            </a>
            <div class="dropdown-menu dropdown-menu-bottom-right sidenav-dp" *dropdownMenu>
                <a class="dropdown-item nohover p-2" (click)="false">
                    <user-level [page]="'SideNavLevel'"
                        [levelLabel]="store.state.common.sidemenuSmall ? 'level.general' : null"></user-level>
                </a>
            </div>
        </li>
        <li class="sidenav-items-divider"></li>
        <li class="dropdown" dropdown placement="right" container="body" #dpUser="bs-dropdown">
            <a href="#" (click)="false" class="sidenav-item"
                tooltip="{{(store.state.common.sidemenuSmall ? userName : '') | translate}}" placement="left"
                container="body" containerClass="nav-tooltip" dropdownToggle>
                <span class="fix-username">{{userInitial}}</span>
                <span>{{userName}}</span>
            </a>
            <div class="dropdown-menu dropdown-menu-bottom-right sidenav-dp" *dropdownMenu>
                <a class="dropdown-item py-2 cursor-pointer" (click)="logout();">
                    <i class="far fa-power-off mr-3" style="font-size:0.9rem"></i>
                    <span>{{ 'header.log_out' | translate }}</span>
                </a>
            </div>
        </li>
    </ul>
</div>
<div class="sidenav-collapse">
    <div *ngIf="serviceId" class="sidenav-dropdown {{isApplicationCollapsed ? 'hidden' : ''}}"
        (mouseleave)="resetCollapsed();">
        <div *ngFor="let item of applicationFileData" class="sidebar-subtitle-section">
            <a class="sidebar-subtitle-section__link" routerLink="{{item.link}}"
                [routerLinkActive]="['sidebar-subtitle-section__link--is-active']"
                [routerLinkActiveOptions]="{exact: true}">
                {{item.translation | translate}}
            </a>
        </div>
    </div>
</div>
</div>

<!-- Page request modal -->

<div *ngIf="showPageRequest" class="requestAccessModal {{store.state.common.sidemenuSmall ? 'nav-collapsed' : ''}}">
    <div class="requestModalContent text-center">
        <img class="mt-3" src="../../../assets//gfx/users.svg">
        <h6 class="my-3">
            <b>{{formatUserName(this.pageOwner)}}</b><br>
            <span>{{"is using this page" | translate}}</span>
        </h6>
        <button class="btn btn-outline-primary" (click)="requestPageAccess()">
            <i class="fad fa-bell mr-2"></i> {{"Request page access" | translate}}
        </button>
        <!--<button class="btn btn-slightly-darker mt-3 btn-md text-uppercase mr-2 align-self-center " (click)="showPageRequest = false;">dismiss request</button>-->
    </div>
</div>

<div *ngIf="pageAccessRequested"
    class="requestAccessModal formio-dialog {{store.state.common.sidemenuSmall ? 'nav-collapsed' : ''}}">
    <div class="requestModalBackdrop"></div>
    <div class="requestModalContent text-center">
        <i class="fad fa-bell mb-3 mt-2 fa-2x text-warning faa-ring animated"></i>
        <h6 class="mb-3">{{"Page access requested by" | translate}}<br><b>{{askingUser}}</b></h6>
        <h6 class="mb-3">{{"Automatic validation in" | translate}} <b>{{counter}}s</b></h6>
        <div class="requestAccessAnswers">
            <button class="btn btn-success ml-4" (click)="acceptPageRequest()"><span id="acceptTimer"></span>{{'Accept'
                | translate}}</button>
            <button class="btn btn-danger" (click)="denyPageRequest()">Decline</button>
        </div>
    </div>
    <audio autoplay loop>
        <source src="../../../assets/gfx/knockknock.wav" type="audio/wav">
    </audio>
</div>

<div *ngIf="askingForPage"
    class="requestAccessModal formio-dialog {{store.state.common.sidemenuSmall ? 'nav-collapsed' : ''}}">
    <div class="requestModalBackdrop"></div>
    <div class="requestModalContent text-center">
        <i class="fad fa-bell mb-3 mt-2 fa-2x text-warning faa-ring animated"></i>
        <h6 class="mb-3">{{"Your request is pending" | translate}}.</h6>
        <h6 class="mb-3">{{"Automatic access in" | translate}} <b>{{counter}}s</b></h6>
        <div class="requestAccessAnswers">
            <button class="btn btn-default" (click)="dismissPageRequest()"><span id="acceptTimer"></span>{{'Cancel' |
                translate}}</button>
        </div>
    </div>
    <audio autoplay loop>
        <source src="../../../assets/gfx/knockknock.wav" type="audio/wav">
    </audio>
</div>

<div *ngIf="pageAccessDenied"
    class="requestAccessModal formio-dialog {{store.state.common.sidemenuSmall ? 'nav-collapsed' : ''}}">
    <div class="requestModalBackdrop"></div>
    <div class="requestModalContent text-center">
        <i class="fad fa-bell mb-3 mt-2 fa-2x text-warning faa-ring animated"></i>
        <h6 class="mb-3"><b>{{"Your request was denied" | translate}}</b></h6>
        <div class="requestAccessAnswers">
            <button class="btn btn-success" (click)="aknowledgePageDenied()">{{'ok' | translate}}</button>
        </div>
    </div>
</div>

<!-- Services Status Drawer -->
<drawer [title]="'Services Status'"
    [isClosed]="isServicesDrawerClosed"
    [showHeaderButtons]="false"
    (closeEvent)="isServicesDrawerClosed = true">
    <div class="drawer-content drawer-direct-content pt-3">
        <ng-container *ngFor="let category of getServiceCategories()">
            <div class="row fields-group" *ngIf="getServicesByCategory(category).length > 0">
                <div class="col d-flex flex-column">
                    <!-- Category header -->
                    <div class="row fields-group-header fields-group-header-collapsible flex-shrink-1"
                         (click)="toggleServiceCategory(category)"
                         [ngClass]="{'expanded': isServiceCategoryOpen(category)}">
                        <div class="col justify-content-between d-flex align-items-center">
                            <label class="input-label mb-0">
                                <i class="far mr-2" [ngClass]="getCategoryIcon(category)"></i>
                                {{ getCategoryDisplayName(category) | translate }}
                                <span class="badge ml-2"
                                      [ngClass]="getCategoryHealthBadge(category)">
                                    {{ getHealthyCountByCategory(category) }}/{{ getServicesByCategory(category).length }}
                                </span>
                            </label>
                            <i class="fas ml-auto"
                               [ngClass]="{'fa-chevron-down': !isServiceCategoryOpen(category), 'fa-chevron-up': isServiceCategoryOpen(category)}"></i>
                        </div>
                    </div>

                    <!-- Category content -->
                    <ng-container *ngIf="isServiceCategoryOpen(category)">
                        <div class="row fields-group-content">
                            <div class="col">
                                <div *ngFor="let service of getServicesByCategory(category)"
                                     class="service-item d-flex align-items-center py-2">
                                    <i class="fad fa-circle-dot mr-3"
                                       [ngClass]="{'text-success': service.health, 'text-danger': !service.health}"></i>
                                    <div class="flex-grow-1 d-flex flex-row">
                                        <div class="service-name mr-2">{{service.displayName}}</div>
                                        <div class="service-version text-muted small">
                                            {{service.version}} <span *ngIf="service.branch !== '?'">({{service.branch}})</span>
                                        </div>
                                    </div>
                                    <span class="badge" [ngClass]="{'badge-success': service.health, 'badge-danger': !service.health}">
                                        {{ service.health ? ('Healthy' | translate) : ('Down' | translate) }}
                                    </span>
                                </div>
                            </div>
                        </div>
                    </ng-container>
                </div>
            </div>
        </ng-container>
    </div>
</drawer>